import React from 'react'
import generic from '../Pics/iconsMonitorizare/generic.png'
import img from '../Pics/iconsMonitorizare/img.png'
import pdf from '../Pics/iconsMonitorizare/pdf.png'
import word from '../Pics/iconsMonitorizare/word.png'
import whatsapp from '../Pics/iconsMonitorizare/whatsapp.png'
import excell from '../Pics/iconsMonitorizare/excell.png'
import chrome from '../Pics/iconsMonitorizare/chrome.png'

export default props => {

    const generateFileType = () =>{
        const {fileName} = props

        if(fileName.icon){
            if( fileName.icon.indexOf("idle") > -1 ) {
                return img
            }
    
            if(fileName.icon.indexOf("whatsapp") > -1){
                return whatsapp
            }
    
            if( fileName.icon.indexOf("msword") > -1 ){
                return word
            }
    
            if( fileName.icon.indexOf("msexcel") > -1 ){
                return excell
            }
    
            if( fileName.icon.indexOf("chrome") > -1 ){
                return chrome
            }
        }else{
            return generic
        }
       

      
    

        return generic
    }


    return (
        <img 
            width={props.customStyle ? (props.customStyle.width ? props.customStyle.width :  props.width) : props.width} 
            height={props.customStyle ? (props.customStyle.height ? props.customStyle.height : props.height) : props.height}
            style={{ margin: props.customStyle ? (props.customStyle.margin ? props.customStyle.margin : 0) : 0 } }
            src={generateFileType()}
        />
    )
}